import { z } from 'zod';
/**
 * Statut d'un run (fulfillment ou Pennylane) — `03` §2
 * (`fulfillmentRuns.status`, `pennylaneRuns.status`).
 */
export const RUN_STATUSES = ['running', 'done', 'done_with_errors', 'failed'];
export const runStatusSchema = z.enum(RUN_STATUSES);
export const RUN_STATUS = {
    running: { code: 'running', label: 'En cours', tone: 'blue' },
    done: { code: 'done', label: 'Terminé', tone: 'green' },
    done_with_errors: { code: 'done_with_errors', label: 'Terminé avec erreurs', tone: 'orange' },
    failed: { code: 'failed', label: 'Échec', tone: 'red' },
};
/** Déclencheur d'un run — `03` §2 (`fulfillmentRuns.trigger`). */
export const RUN_TRIGGERS = ['schedule', 'manual'];
export const runTriggerSchema = z.enum(RUN_TRIGGERS);
export const RUN_TRIGGER = {
    schedule: { code: 'schedule', label: 'Planifié', tone: 'gray' },
    manual: { code: 'manual', label: 'Manuel', tone: 'blue' },
};
/**
 * Mode global d'un flux (fulfillment, Pennylane) — `01` §5.5.
 * `simulation` est la valeur initiale à la bascule.
 */
export const FLOW_MODES = ['simulation', 'active'];
export const flowModeSchema = z.enum(FLOW_MODES);
export const FLOW_MODE = {
    simulation: {
        code: 'simulation',
        label: 'Simulation',
        tone: 'orange',
        description: 'Lecture seule : rien n’est écrit chez Shopify ni chez Martelet.',
    },
    active: { code: 'active', label: 'Actif', tone: 'green' },
};
//# sourceMappingURL=run.js.map